import { CompanySize } from 'lib/types/company';
import _ from 'lodash';
import { createContext, useContext } from 'react';

interface ISalesRequestContext {
  /** The `companySize` value associated with the current company. */
  companySize?: CompanySize;

  /** The value of the `interest` parameter. */
  interest?: string;

  /** Returns `true` if the sales request modal is open. */
  isSalesRequestModalOpen: boolean;

  /** Set the company size for the current company. */
  setCompanySize?: (size: CompanySize) => void;

  /** Set the value of the ChiliPiper `interest` parameter. */
  setInterest: (interest: string) => void;

  /** Function to toggle the sales request modal. */
  toggleSalesRequestModal: () => void;
}

export const useSalesRequestContext = () => useContext(SalesRequestContext);

export const SalesRequestContext = createContext<ISalesRequestContext>({
  companySize: undefined,
  interest: undefined,
  isSalesRequestModalOpen: false,
  setCompanySize: _.noop,
  setInterest: _.noop,
  toggleSalesRequestModal: _.noop,
});
